import type { FC, ReactNode } from 'react';

interface PageContainerProps {
  children?: ReactNode;
}

export const PageContainer: FC<PageContainerProps> = ({ children }) => (
  <div className="relative flex h-screen flex-col">{children}</div>
);
